/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Token_InvalidInputs */

const es_co2_password_reset_token_invalid = /** @type {(inputs: Password_Reset_Token_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El enlace de recuperación no es válido, expiró o ya fue utilizado.`)
};

/**

* @param {Password_Reset_Token_InvalidInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const password_reset_token_invalid = /** @type {((inputs?: Password_Reset_Token_InvalidInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Token_InvalidInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_password_reset_token_invalid(inputs)
});